import { Mixpanel } from '../init';

export const expDetailsPageViewEvent = (experience: any) => {
   Mixpanel.track('Exp Details -  Page View', {
      experienceId: experience._id,
      experienceName: experience.name,
      experienceCity: experience.city,
      experienceCategory: experience.category.title,
      providerName: experience.organizer_name,
   });
};

export const expDetailsBookOnlineBtnEvent = ({
   experienceId,
   experienceName,
   experienceCity,
   experienceCategory,
   providerName,
}: any) => {
   Mixpanel.track('Exp Details - Book Online Btn', {
      experienceId: experienceId,
      experienceName: experienceName,
      experienceCity: experienceCity,
      experienceCategory: experienceCategory,
      providerName: providerName,
   });
};

export const expDetailsCallToBookBtnEvent = ({
   experienceId,
   experienceName,
   providerName,
}: any) => {
   Mixpanel.track('Exp Details - Call to Book Btn', {
      experienceId: experienceId,
      experienceName: experienceName,
      providerName: providerName,
   });
};

export const expDetailsMessageSupportBtnEvent = ({
   experienceId,
   experienceName,
   providerName,
}: any) => {
   Mixpanel.track('Exp Details - Message Support Btn', {
      experienceId: experienceId,
      experienceName: experienceName,
      providerName: providerName,
   });
};

export const expDetailsCallHYSupportBtnEvent = ({
   experienceId,
   experienceName,
   providerName,
}: any) => {
   Mixpanel.track('Exp Details - Call HY Support Btn', {
      experienceId: experienceId,
      experienceName: experienceName,
      providerName: providerName,
   });
};

export const expDetailsOrganizerPageBtnEvent = ({
   experienceId,
   experienceName,
   providerName,
}: any) => {
   Mixpanel.track('Exp Details - Organizer Page Btn', {
      experienceId: experienceId,
      experienceName: experienceName,
      providerName: providerName,
   });
};

export const expDetailsShareExpBtnEvent = ({ experienceId, experienceName, providerName }: any) => {
   Mixpanel.track('Exp Details - Share Exp Btn', {
      experienceId: experienceId,
      experienceName: experienceName,
      providerName: providerName,
   });
};

export const expDetailsSellYourExpBtnEvent = ({
   experienceId,
   experienceName,
   providerName,
}: any) => {
   Mixpanel.track('Exp Details - Sell Your Exp Btn', {
      experienceId: experienceId,
      experienceName: experienceName,
      providerName: providerName,
   });
};

export const offlineExperienceNotifyMeBtnEvent = ({
   experienceId,
   experienceCity,
   experienceCategory,
   experienceName,
   providerName,
}: any) => {
   Mixpanel.track('Exp Details - Notify Me Btn', {
      experienceCity: experienceCity,
      experienceCategory: experienceCategory,
      experienceId: experienceId,
      experienceName: experienceName,
      providerName: providerName,
   });
};

export const offlineExperienceMobileSubmitBtnEvent = ({
   mobile,
   experienceId,
   experienceCity,
   experienceCategory,
   experienceName,
   providerName,
}: any) => {
   Mixpanel.track('Exp Details - Notify Mobile Submit Btn', {
      mobile: mobile,
      experienceCity: experienceCity,
      experienceCategory: experienceCategory,
      experienceId: experienceId,
      experienceName: experienceName,
      providerName: providerName,
   });
};

export const offlineExperienceMobileSubmitBtnSuccessEvent = ({
   mobile,
   experienceId,
   experienceCity,
   experienceCategory,
   experienceName,
   providerName,
}: any) => {
   Mixpanel.track('Exp Details - Notify Mobile Submit Btn Success', {
      mobile: mobile,
      experienceCity: experienceCity,
      experienceCategory: experienceCategory,
      experienceId: experienceId,
      experienceName: experienceName,
      providerName: providerName,
   });
};

export const offlineExperienceMobileSubmitBtnFailedEvent = ({
   error,
   mobile,
   experienceId,
   experienceCity,
   experienceCategory,
   experienceName,
   providerName,
}: any) => {
   Mixpanel.track('Exp Details - Notify Mobile Submit Btn Failed', {
      error: error,
      mobile: mobile,
      experienceCity: experienceCity,
      experienceCategory: experienceCategory,
      experienceId: experienceId,
      experienceName: experienceName,
      providerName: providerName,
   });
};

export const expDetailsGetDirectionsBtnEvent = ({
   experienceId,
   experienceName,
   providerName,
}: any) => {
   Mixpanel.track('Exp Details - Get Directions Btn', {
      experienceId: experienceId,
      experienceName: experienceName,
      providerName: providerName,
   });
};
